/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  ToggleSwitchController,
  SelectController,
  RangeController,
  ChoiceBoxController,
  SimpleColorPickerController,
} from '../../../controllers/Base';

import fontOptions from '../../../utils/controllersUtils/options';

const LabelControllers = ({
  handle,
  config,
  extend,
  setExtend,
  isGlobalFontActive,
}) => (
  <>
    <ControllersGroup title="Rótulos" id="labels" extend={extend} setExtend={setExtend}>
      <ToggleSwitchController
        label="Habilitar rótulos"
        handle={handle}
        kWord="EnableLabelControl"
        configValue={config?.EnableLabelControl?.checked}
        firstOption=""
        secondOption=""
        fullWidth
      />
      {config.LayoutControl !== 'horizontal' && (
        <ChoiceBoxController
          label="Posição dos rótulos"
          handle={handle}
          kWord="LabelFormatControl"
          options={[
            { value: 'Superior', label: 'Superior', id: 'Superior' },
            { value: 'Central', label: 'Central', id: 'Central' },
          ]}
          configValue={config?.LabelFormatControl}
          fullWidth
          disabled={!config?.EnableLabelControl?.checked}
        />
      )}
      <ChoiceBoxController
        label="Cor"
        handle={handle}
        kWord="LabelTextColorControl2"
        options={[
          { value: 'brighter', label: 'Clara', id: 'brighter' },
          { value: 'darker', label: 'Escura', id: 'darker' },
          { value: 'custom', label: 'Customizada', id: 'custom' },
        ]}
        configValue={config?.LabelTextColorControl?.modifiers?.[0]?.[0] || 'custom'}
        fullWidth
        disabled={!config?.EnableLabelControl?.checked}
      />
      {config?.LabelTextColorControl?.value?.toString() !== '0' && typeof config?.LabelTextColorControl !== 'string' && (
        <RangeController
          label="Opacidade"
          handle={handle}
          kWord="LabelTextOpacityControl"
          configValue={config?.LabelTextColorControl?.modifiers?.[0]?.[1] || '1'}
          min={0}
          max={2}
          step={0.1}
          precision={1}
          fullWidth
          disabled={!config?.EnableLabelControl?.checked}
        />
      )}
      {config?.LabelTextColorControl?.value?.toString() !== '0' && typeof config?.LabelTextColorControl === 'string' && (
        <SimpleColorPickerController
          label="Cor customizada"
          handle={handle}
          kWord="LabelTextColorControl"
          configValue={config?.LabelTextColorControl}
          orientation="row"
          fullWidth
          disabled={!config?.EnableLabelControl?.checked}
        />
      )}
      <SelectController
        label="Fonte"
        handle={handle}
        kWord="LabelsFontFamilyControl"
        options={fontOptions}
        configValue={config?.LabelsFontFamilyControl?.value}
        text={config?.UseGlobalFont !== false && isGlobalFontActive ? 'Utilizando fonte global' : ''}
        disabled={!config?.EnableLabelControl?.checked || (
          config?.UseGlobalFont !== false && isGlobalFontActive
        )}
      />
      <InputLineController
        label="Tamanho"
        handle={handle}
        kWord="LabelsFontSizeControl"
        configValue={config?.LabelsFontSizeControl?.value}
        min={1}
        max={30}
        step={1}
        precision={0}
        isNumber
        disabled={!config?.EnableLabelControl?.checked}
      />
      <RangeController
        label="Rotação"
        handle={handle}
        kWord="LabelRotationControl"
        configValue={config?.LabelRotationControl}
        min={-180}
        max={180}
        fullWidth
        disabled={!config?.EnableLabelControl?.checked}
      />
      <RangeController
        label="Posição horizontal"
        handle={handle}
        kWord="LabelTranslateX"
        configValue={config?.LabelTranslateX}
        min={-500}
        max={500}
        fullWidth
        disabled={!config?.EnableLabelControl?.checked}
      />
      <RangeController
        label="Posição vertical"
        handle={handle}
        kWord="LabelTranslateY"
        configValue={config?.LabelTranslateY}
        min={-500}
        max={500}
        fullWidth
        disabled={!config?.EnableLabelControl?.checked}
      />
      <InputLineController
        label="Prefixo"
        handle={handle}
        kWord="PrefixControl"
        configValue={config?.PrefixControl}
        fullWidth
        disabled={!config?.EnableLabelControl?.checked}
      />
      <InputLineController
        label="Sufixo"
        handle={handle}
        kWord="SufixControl"
        configValue={config?.SufixControl}
        fullWidth
        disabled={!config?.EnableLabelControl?.checked}
      />
      {config?.DataFormatValueType === 'percentual' && (
        <>
          <ChoiceBoxController
            label="Casas decimais"
            handle={handle}
            kWord="Decimals"
            options={[
              { value: 'auto', label: 'Automático', id: 'auto' },
              { value: 'fixed', label: 'Customizável', id: 'fixed' },
            ]}
            configValue={config?.Decimals || 'auto'}
            fullWidth
            disabled={!config?.EnableLabelControl?.checked}
          />
          <RangeController
            label="Quantidade de casas percentuais"
            handle={handle}
            kWord="separadorNumericoCasas"
            configValue={config?.separadorNumericoCasas}
            min={0}
            max={5}
            step={1}
            precision={0}
            fullWidth
            disabled={!config?.EnableLabelControl?.checked || config?.Decimals !== 'fixed'}
          />
        </>
      )}
      {config?.DataFormatValueTypeAlt !== 'none' && (
        <ToggleSwitchController
          label="Quebrar linha"
          handle={handle}
          kWord="LabelLineBreak"
          configValue={config?.LabelLineBreak}
          firstOption=""
          secondOption=""
          fullWidth
        />
      )}
    </ControllersGroup>
  </>
);

LabelControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  isGlobalFontActive: PropTypes.bool,
};

export default LabelControllers;
